import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../../cmsHooks/useIndexPageData'

import { Subheader, ActionButton } from '../../../ui'
import device from '../../../../utilities/device'

const ShadowBox = styled.div`
  border-radius: 3px;
  padding: 50px;
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.25);

  @media ${device.laptop} {
    margin: 50px 0px;
    padding: 50px;
  }
  @media ${device.mobileL} {
    padding: 30px;
  }
`
const Para = styled.p`
  margin-top: 15px;
  margin-bottom: 40px;
  line-height: 1.5em;
`
const PartnerBox = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <ShadowBox>
      <Subheader>
        <CMS.Text name="Partner w Talus headline" data={data} />
      </Subheader>
      <Para>
        <CMS.Text name="Partner w Talus para" data={data} />
      </Para>
      <Link to="/contact">
        <ActionButton>
          <CMS.Text name="Partner w Talus button" data={data} />
        </ActionButton>
      </Link>
    </ShadowBox>
  )
}

export default PartnerBox
